import React from 'react';
import {Button} from 'semantic-ui-react';

const FileActionButtons = ({file, onEdit, onView, onDelete, onDownload}) => {
    return (
        <div style={{display: 'flex', gap: '12px', alignItems: 'flex-start', flexWrap: 'wrap'}}>
            {(file.status === 'Completed' || file.status === 'Error') && (
                <Button
                    icon
                    size="small"
                    onClick={() => onEdit(file.id)}
                    title="Редактировать"
                    className="ui button square no-border icon"
                >
                    <i className="fa fa-pencil"></i>
                </Button>
            )}
            {file.status === 'ParcelsCreated' && (
                <Button
                    icon
                    size="small"
                    onClick={() => onView(file)}
                    title="Посмотреть отправления"
                    className="ui button square no-border icon"
                >
                    <i className="fa fa-list"></i>
                </Button>
            )}
            {file.hasSourceFile && (
                <Button
                    icon
                    size="small"
                    onClick={() => onDownload(file.id)}
                    title="Скачать исходный файл"
                    className="ui button square no-border icon"
                >
                    <i className="fa fa-download"></i>
                </Button>
            )}
            {file.canDelete && (
                <Button
                    icon
                    size="small"
                    onClick={() => onDelete(file.id)}
                    title="Удалить"
                    className="ui button square no-border icon"
                >
                    <i className="fa fa-trash"></i>
                </Button>
            )}
        </div>
    );
};

export default FileActionButtons;




// WEBPACK FOOTER //
// ./App/pages/massUpload/components/FileActionButtons.jsx